import Vue from 'vue'
import Router from 'vue-router'
import common from './common' //公共模块
import basic from './basic' //基础数据
import attendance from './attendance' //考勤
import csmstimetable from './csmstimetable' //一人一课表
import operationalAnalysis from './operationalAnalysis' //智慧办公
import systemSet from './systemSet' //系统设置
import evaluation from './evaluation' //智慧评价
import educationAffairs from './educationAffairs' //智慧教务
import schoolAffairs from './schoolAffairs' //智慧校务
import homeSchool from './homeSchool' // 家校互通
import dataAnalysis from './dataAnalysis' // 数据分析
import infoPublic from './infoPublic'//班牌信发
import xyUtils from '@/common/utils'

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {//解决重复点击按钮router报错
  return originalPush.call(this, location).catch(err => err)
}

const Home = () => import(/* webpackChunkName: "common" */ '@/pages/common/views/home/Home.vue')
const HomeSchoolFrame = () => import(/* webpackChunkName: "common" */ '@/pages/common/views/home/HomeSchoolFrame.vue')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: '/',
  routes: [
    ...common,
    {
      path: '/home',
      name: 'home',
      component: Home,
      children: [
        ...basic,
        ...attendance,
        ...csmstimetable,
        ...operationalAnalysis,
        ...systemSet,
        ...evaluation,
        ...educationAffairs,
        ...schoolAffairs,
        ...dataAnalysis,
        ...infoPublic
      ]
    },
    {
      path: '/homeSchool',
      name: 'HomeSchoolFrame',
      component: HomeSchoolFrame,
      children: [
        ...homeSchool,
      ]
    }
  ],
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
})


router.beforeEach((to, from, next) => {
  let token = xyUtils.getCookie('.XYTOKEN') ? xyUtils.getCookie('.XYTOKEN') : 0;
  let paramsObj = xyUtils.parseQueryString(location.href)
  if (paramsObj.token) {
    token = paramsObj.token
    xyUtils.setCookie(token)
  }
  const fullPath = to.fullPath.split('?')
  if (fullPath.length > 1){
    let third = fullPath[1].split('&')
    for (let i = 0, len = third.length; i < len; i++) {
      let o = third[i].split('=')[0]
      if (o.toLowerCase() === 'token' || o.toLowerCase() === 'Token') {
        let Token1 = third[i].split('=')[1]
        xyUtils.removeCookie('.XYTOKEN')
        xyUtils.setCookie(Token1)
      }
    }
  }

  let role = localStorage.getItem('role') !== null ? localStorage.getItem('role') : -1;
  document.title = localStorage.getItem('webSiteTitle') ? localStorage.getItem('webSiteTitle') : '登录'
  if ((token && to.name === 'login' && !paramsObj.openID) || (token && !to.name )) {
    switch (Number(role)) {
      case 4:
        console.log(role)
        //next('xyParent');
        break;
      default: {
        next('xyIndex');
      }
    }
  } else {
    next()
  }
  if (!token) {
    if (to.name === 'visitApplyDetails') {
      next('/login?isApplyDetails=true')
    } else if (to.name === 'login' || to.name === 'VistorLogin' ||
     to.name === 'VisitLogin' || to.name === 'visitApply' || to.name === 'visitDetails' || to.name === 'visitSubmission' || to.name === 'InvitationLink') {
      next()
    } else {
      next('/login')
    }
  }
  if (to.meta.title) {
    /* 动态修改页面title */
    document.title = to.meta.title;
  }
  // if (to.path === '/') {
  //   if (token) {
  //     switch (Number(role)) {
  //       case 4:
  //         next('xyParent');
  //         break;1
  //       default: {
  //         next('xyIndex');
  //       }
  //     }
  //   } else {
  //     next('/login')
  //   }
  // } else {
  //   next()
  // }
})

export default router
